import {combineReducers, applyMiddleware, createStore, compose} from 'redux';
import logger from 'redux-logger';
import {communityReducer, noticesReducer} from './community';
import {editingProfileReducer, profileReducer, reviewsReducer, suggestionsReducer} from './profile';
import {chatReducer, notificationsReducer, sessionReducer} from './user';
import {uiReducer} from './chrome';
import confirmationReducer from './widgets/confirmation.reducer';
import {googleAnalytics} from './reactGAmiddleware';
import {categoryReducer} from './category';
import {searchReducer} from './search';
import {streamReducer} from './stream';
import {couponsReducer} from './community';
import {ProfileCouponReducer} from './profile/';
import thunk from 'redux-thunk';
import {connectRouter, routerMiddleware} from 'connected-react-router';

const composeEnhancers = (window && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const getEnhancers = history =>
	process.env.NODE_ENV === 'production'
		? composeEnhancers(applyMiddleware(routerMiddleware(history), googleAnalytics, thunk)) // prod
		: process.env.NODE_ENV === 'test'
		? composeEnhancers(applyMiddleware(routerMiddleware(history), thunk)) // test
		: composeEnhancers(applyMiddleware(routerMiddleware(history), thunk, logger)); // dev

/**
 * Create B2Me Redux store
 */
const createB2MeStore = (history, initialState) =>
	createStore(
		combineReducers({
			suggestions: suggestionsReducer,
			search: searchReducer,
			profile: profileReducer,
			editingProfile: editingProfileReducer,
			community: communityReducer,
			ui: uiReducer,
			session: sessionReducer,
			categories: categoryReducer,
			notices: noticesReducer,
			reviews: reviewsReducer,
			chat: chatReducer,
			notifications: notificationsReducer,
			confirmation: confirmationReducer,
			stream: streamReducer,
			coupon: couponsReducer,
			profileCoupon: ProfileCouponReducer,
			router: connectRouter(history),
			lastAction: (state = null, action) => action
		}),
		initialState ? initialState : getEnhancers(history),
		initialState ? getEnhancers(history) : undefined
	);

export default createB2MeStore;



// WEBPACK FOOTER //
// ./src/createB2MeStore.js